import { render, staticRenderFns } from "./index-admin.vue?vue&type=template&id=40029339&scoped=true"
import script from "./index-admin.vue?vue&type=script&lang=js"
export * from "./index-admin.vue?vue&type=script&lang=js"
import style0 from "./index-admin.vue?vue&type=style&index=0&id=40029339&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40029339",
  null
  
)

export default component.exports